module.exports = __webpack_public_path__ + "static/media/ambie.75ee230e.png";